<!--登录和注册组件-->
<template>
  <div v-if="isLogin === 1">
    <el-form :model="loginForm" :rules="loginRules" ref="loginFormRef">
      <el-form-item label="用户名" label-width="80px" prop="username">
        <el-input v-model="loginForm.username"></el-input>
      </el-form-item>
      <el-form-item label="密码" label-width="80px" prop="password">
        <el-input type="password" v-model="loginForm.password"></el-input>
      </el-form-item>
    </el-form>
    <el-button type="primary" style="width:460px;" @click="login(loginFormRef)">{{loginText}}</el-button>
    <div class="bottom-area">
      <div class="error-msg">{{ errorMsg }}</div>
      <div class="register-link">
        <div>还没有账号？</div>
        <el-link :underline="false" @click="isLogin=0">立即注册</el-link>
        <div>一个</div>
      </div>
    </div>
  </div>
  <div v-else>
    <el-form :model="registerForm" ref="registerFormRef">
      <el-form-item label="用户名" label-width="80px" prop="username">
        <el-input v-model="registerForm.username"></el-input>
      </el-form-item>
      <el-form-item label="密码" label-width="80px" prop="password">
        <el-input type="password" v-model="registerForm.password"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" label-width="80px" prop="password">
        <el-input type="password" v-model="registerForm.confirmPassword"></el-input>
      </el-form-item>
    </el-form>
    <el-button type="primary" style="width:460px;" @click="register(registerFormRef)">{{registerText}}</el-button>
    <div class="bottom-area">
      <div class="error-msg">{{ errorMsg }}</div>
      <div class="register-link">
        <div>已有账号？</div>
        <el-link :underline="false" @click="isLogin=1">前往登录</el-link>
      </div>
    </div>
  </div>
</template>
<script setup>
import {ref, defineProps, reactive, defineEmits} from 'vue'
import CONFIG from '@/assets/config.json'
import {useStore} from 'vuex'
import axios from 'axios'
import {registeUser} from '@/api'
import {ElMessageBox} from 'element-plus'
const props = defineProps({
  type: {
    type: Number,
    default: 1
  }
})
const store = useStore()
const emits = defineEmits(['complete'])
let isLogin = ref(props.type)
let errorMsg = ref('')
let loginText = ref('登录')
let registerText = ref('注册')
const loginFormRef = ref()
const registerFormRef = ref()
const loginRules = reactive({
  username: [{
    required: true, message: '请输入你的账号', trigger: 'blur'
  }],
  password: [{
    required: true, message: '请输入你的密码', trigger: 'blur'
  }]
})
const loginForm = reactive({
  username: '',
  password: ''
})
const registerForm = reactive({
  username: '',
  password: '',
  confirmPassword: ''
})
const login = async (formEl) => {
  errorMsg.value = ''
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
      loginText.value = '登录中……'
      axios.post(CONFIG.BASE_API_URL + 'login', loginForm).then(data => {
        if (data.data.code === 200) {
          store.commit('setToken', data.data.data)
          emits('complete')
        } else {
          errorMsg.value = data.data.msg
        }
        loginText.value = '登录'
      }).catch(() => {
        errorMsg.value = "登录异常，请稍后再试"
        loginText.value = '登录'
      })
    }
  })
}
const register = (formEl) => {
  errorMsg.value = ''
  if (!formEl) return
  if (registerForm.username.trim() === '') {
    errorMsg.value = '注册账号不能为空'
  } else if (registerForm.password.trim() === '') {
    errorMsg.value = '密码不能为空'
  } else if (registerForm.confirmPassword.trim() === '') {
    errorMsg.value = '确认密码不能为空'
  } else if (registerForm.password !== registerForm.confirmPassword) {
    errorMsg.value = '两次密码输入不一致'
  } else {
    registeUser(registerForm).then(res => {
      if (res.code === 200) {
        ElMessageBox.alert('账号注册成功，前往登录', '提示' ,{
        confirmButtonText: '确定',
        showClose: false,
        callback: action => {
          isLogin.value = 1
        }})
      } else {
        errorMsg.value = res.msg
      }
    })
  }
}
</script>
<style scoped lang="scss">
.bottom-area{
  height: 30px;
  line-height: 30px;
  text-align: right;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .register-link{
    display: flex;
  }
  .error-msg{
    color: red;
  }
}
</style>